import toast from 'utils/toast'
import institutionAPI from 'services/institutionAPI'

type Params = {
  notificationId?: string
}

export default async function markNotificationAsReaded({ notificationId }: Params) {
  const response = await institutionAPI({
    method: 'PATCH',
    url: `/notification/notification/notification/${notificationId}/read`,
  })

  if (!response?.header?.success) {
    toast.error(response?.header?.message)
  }

  return response
}
